import { render, staticRenderFns } from "./CourseAdPopup.vue?vue&type=template&id=0bb24e52&scoped=true&"
import script from "./CourseAdPopup.vue?vue&type=script&lang=js&"
export * from "./CourseAdPopup.vue?vue&type=script&lang=js&"
import style0 from "./CourseAdPopup.vue?vue&type=style&index=0&id=0bb24e52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb24e52",
  null
  
)

export default component.exports